import { Outlet, createFileRoute } from '@tanstack/react-router';
import { guardSection } from '../../shell/guard.ts';

// Start here (T33b, spec F14): the overview, the lessons, the quiz and the owner's completion
// table share the section gate. Every role has start.read (spec P10).
export const Route = createFileRoute('/_authed/start')({
  beforeLoad: guardSection('/start'),
  component: Outlet,
});
